import SocketGuruService from 'ember-socket-guru/services/socket-guru';
import ENV from 'bullitttime-uploader/config/environment';

export default class SocketGuru extends SocketGuruService {
	constructor() {
		super({
			config: {
				host: ENV.uploaderBackendProtocol+"://"+ENV.uploaderBackendHost+":"+ENV.uploaderBackendPort,
				namespace: ENV.uploaderBackendNamespace ? "/"+ENV.uploaderBackendNamespace : ""
			},
			observedChannels: ['stdOut','stdErr']
		});
	}
}